// リリースフラグの種別・ラベル・説明文（client / admin 共通）
//
// 注: ここの型はバックエンドの `ReleaseFlagType` enum と同期する
// （backend/openapi/components/schemas/commons/release_flag.yaml）

/** リリースフラグの種別 */
export type ReleaseFlagType =
  | 'settlement_statistics_converter'
  | 'revenue_expenditure_account_items'
  | 'system_feedback';

/** 短い表示ラベル */
export const RELEASE_FLAG_LABELS: Record<ReleaseFlagType, string> = {
  settlement_statistics_converter: '決算統計コンバーター',
  revenue_expenditure_account_items: '歳入歳出科目ナレッジ',
  system_feedback: 'システム内問い合わせ',
};

/** クライアントアプリでの挙動を示す説明文 */
export const RELEASE_FLAG_DESCRIPTIONS: Record<ReleaseFlagType, string> = {
  settlement_statistics_converter: '決算統計コンバーターの公開を制御',
  revenue_expenditure_account_items:
    '汎用AIチャットの「ナレッジを追加」での歳入歳出科目の選択肢の公開を制御',
  system_feedback: 'システム内問い合わせ（FB・報告）フォーム導線の公開を制御',
};
